import { useEffect, useRef, useState } from "react";
import "../styles/email-menu.css";

const CONTACT_EMAIL = "info@racecitytrucksolutions.com";

const EMAIL_OPTIONS = [
  { label: "Default Mail App", href: `mailto:${CONTACT_EMAIL}` },
  { label: "Gmail", href: `https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT_EMAIL}` },
  { label: "Outlook", href: `https://outlook.live.com/mail/0/deeplink/compose?to=${CONTACT_EMAIL}` },
  { label: "Yahoo Mail", href: `https://compose.mail.yahoo.com/?to=${CONTACT_EMAIL}` },
];

export default function EmailMenu({ className }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  const copyEmail = () => {
    navigator.clipboard.writeText(CONTACT_EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <span className={"email-menu" + (className ? " " + className : "")} ref={ref}>
      <button type="button" className="email-menu__trigger" onClick={() => setOpen((o) => !o)}>
        {CONTACT_EMAIL}
      </button>
      {open && (
        <div className="email-menu__dropdown">
          {EMAIL_OPTIONS.map((opt) => (
            <a key={opt.label} href={opt.href} target="_blank" rel="noreferrer"
              className="email-menu__option" onClick={() => setOpen(false)}>
              {opt.label}
            </a>
          ))}
          <button type="button" className="email-menu__option" onClick={copyEmail}>
            {copied ? "Copied!" : "Copy Email Address"}
          </button>
        </div>
      )}
    </span>
  );
}
